import Widget from '../../BookingCalendar/Widget';

export default Widget;
